import React from "react";
import { Box, Flex, GridItem, Text, Tooltip } from "@chakra-ui/react";
import AppRemittanceStatusLabel from "@/features/ui/app-remittance-status-label";
import CustomIcon from "../../../../../../public/icons-v1_1";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import RemittanceStatusBadge from "@/features/my-order/components/RemittanceStatusBadge";
import { CombinedRemittanceStatus } from "@/features/invoices/invoice.type";

interface Props {
  amount?: number;
  // 유로 송금 프로포마의 상품 대금은 유로
  currency?: "KRW" | "EUR";
  variant?:
    | "PROFORMA"
    | "PROFORMA_DIFFERENCE"
    | "FUNDS_REQUEST"
    | "ORDER_CONFIRMATION"
    | "DEPOSIT_DIFFERENCE";
  status: CombinedRemittanceStatus | "ERROR";
  onFileDownloadClick?: () => void;
  hasData?: boolean;
  isRemittanceRequired?: boolean;
}

function OrderHistorySubPriceInfo({
  amount = 0,
  currency = "KRW",
  variant,
  status,
  onFileDownloadClick,
  hasData = true,
}: Props) {
  const { tTitle, tSentence, tCurrencyKrw, tCurrencyString } = useI18nHelper();
  const variantToNameMap = {
    PROFORMA: "proforma",
    PROFORMA_DIFFERENCE: "proforma_difference",
    FUNDS_REQUEST: "funds_request",
    ORDER_CONFIRMATION: "order_confirmation_invoice",
    DEPOSIT_DIFFERENCE: "order_history:invoice.deposit_difference",
  };

  return (
    <Flex
      alignItems={"center"}
      justifyContent={"space-between"}
      textStyle={"body-md-medium"}
      color={"#6F6F6C"}
      paddingLeft={"24px"}
      flex={1}
    >
      <Flex alignItems={"center"} gap={"8px"}>
        <Flex alignItems={"center"}>
          <Text marginRight={"4px"}>ㄴ</Text>
          <Text marginRight={"2px"}>
            {tTitle(variantToNameMap[variant ?? "PROFORMA"])}
          </Text>
          {onFileDownloadClick && (
            <Tooltip label={tTitle("download_document")}>
              <Box
                color={"#8F8F8C"}
                _hover={{
                  color: "#1272EF",
                }}
                _active={{
                  color: "#00417D",
                }}
              >
                <CustomIcon
                  src={"document-down"}
                  width={16}
                  height={16}
                  onClick={onFileDownloadClick}
                />
              </Box>
            </Tooltip>
          )}
        </Flex>
        {status !== "ERROR" && hasData && (
          <RemittanceStatusBadge status={status} />
        )}
      </Flex>
      <Text
        color={
          hasData
            ? status === "REMITTANCE_REQUIRED"
              ? "#CC1D1D"
              : "inherit"
            : "#C0C0C0"
        }
      >
        {hasData
          ? amount === 0
            ? "-"
            : currency === "EUR"
            ? tCurrencyString(amount, { type: "SYMBOL", code: "EUR" })
            : tCurrencyKrw(amount)
          : tSentence("to_be_updated")}
      </Text>
    </Flex>
  );
}

export default OrderHistorySubPriceInfo;
